import axios from "axios";
import { isTestEndpoint } from "./helpers/isDev";

let baseUrl;
let apiUrl;
let signupUrl;
let coverageUrl;
let exApiUrl = window.i3.siteExApiURL;

if(isTestEndpoint()) {
    baseUrl = window.i3.siteURL;
    apiUrl = window.i3.siteApiURL+'-testing/';
    signupUrl = window.i3.signupApiURL;
    coverageUrl = window.i3.coverageApiURL;
} else if(false && window.location.host.indexOf('localhost') !== -1) {
    baseUrl = 'http://i3-broadband.local/';
    apiUrl = baseUrl + '/api/buyflow/';
} else {
    baseUrl = window.i3.siteURL;
    apiUrl = window.i3.siteApiURL+'/';
    signupUrl = window.i3.signupApiURL;
    coverageUrl = window.i3.coverageApiURL;
}

const unauthenticatedApi = axios.create({
    baseURL: apiUrl,
});

const coverageApi = axios.create({
    withCredentials: true,
    baseURL: coverageUrl,
    
    headers: {
        'Content-Type': 'application/json',        
    }
});
const signupApi = axios.create({
    withCredentials: true,
    baseURL: signupUrl,
    
    headers: {
        'Content-Type': 'application/json'
    }
});

const ossApi = axios.create({
    withCredentials: true,
    baseURL: exApiUrl+'i3-oss-api/',
    
    headers: {
        'Content-Type': 'application/json'
    }
});

export {
    baseUrl,
    apiUrl,    
    signupApi,
    unauthenticatedApi,
    coverageApi,
    ossApi,
    
};
